export default function FormItem({
  id,
  setId,
  icon,
  field,
  placeholder,
  type = "text",
}) {
  return (
    <div className="flex gap-1 p-4 my-2">
      <div
        className="
                flex justify-center
                border border-gray-300 rounded-s-md 
                w-8  
                bg-white"
      >
        {icon}
      </div>
      <input
        type={type}
        value={id[field]}
        onChange={(e) =>
          setId((prev) => ({ ...prev, [field]: e.target.value }))
        }
        required
        placeholder={placeholder}
        className="border border-gray-300 hover:border-gray-600 rounded-e-md p-1 w-full"
      />
    </div>
  );
}
